
export default function drawPalette(params) {

    const {
        ctx,
        x,
        y,
        width,
        height,
        swatches,
        vertical
    } = params;

    // normalize height
    let denom = 0;
    for(const swatch of swatches){
        denom += swatch.percent;
    }

    const getSwatchHeight = pct => height / denom * pct;
    let yOffset = 0;

    // clear room for the palette
    if (vertical){
        ctx.clearRect(y, x, height, width);

    } else {
        ctx.clearRect(x, y, width, height);
    }
    // ctx.clearRect(x, y, width, height);

    swatches.forEach((s, i, arr) => {

        const [r,g,b ]= s.color;
        // const swatchHeight = getSwatchHeight(s.percent);

        const swatchHeight = params.proportional ?  getSwatchHeight(s.percent) : height / (swatches.length - 1) ;

        ctx.fillStyle = `rgb(${r}, ${g}, ${b})`;

        if (vertical){
            ctx.fillRect(
                yOffset,
                x,
                swatchHeight,
                width,
            );
    
        } else {
            ctx.fillRect(
                x,
                yOffset,
                width,
                swatchHeight
            );
    
        }
        // ctx.fillRect(
        //     x,
        //     yOffset,
        //     width,
        //     swatchHeight
        // );

        yOffset += swatchHeight;

    })


}